import { GLOBAL_HOOK_NAMESPACE } from '../helper';
const scope = typeof window !== 'undefined' ? window : global;
const instance = scope[GLOBAL_HOOK_NAMESPACE] || (scope[GLOBAL_HOOK_NAMESPACE] = {});
const memoised = {};

function get(name) {
  let _default = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (Object.prototype.hasOwnProperty.call(instance, name)) {
    memoised[name] = instance[name];
  } else if (Object.prototype.hasOwnProperty.call(memoised, name)) {
    instance[name] = memoised[name];
  } else {
    memoised[name] = _default;
    instance[name] = memoised[name];
  }

  return memoised[name];
}

export const application = () => instance;
export const dependencies = () => get('dependencies', []);